<script lang="ts">
  import { fade } from "svelte/transition";
</script>
<div
  class="w-full h-full inline-block"
  in:fade={{ duration: 150 }}
>
  <slot />
</div>
